module.exports = __webpack_public_path__ + "img/CM-BS-24-BMW-Playful.d802ae25.jpg";